module.exports = __webpack_public_path__ + "img/menu_gomb_palyazatok.cf54f079.png";